import Cookies from 'js-cookie';
import { GrowthBook, BrowserCookieStickyBucketService } from '@growthbook/growthbook';
import {
  SVN_COOKIE_NAME,
  COOKIE_CUSTOMER_ID_NAME,
  INIT_TIMEOUT_MS,
  UTM_ATTRIBUTES_MAP,
} from './constants';
import getBrowser from './utils/get-browser';
import getDeviceType from './utils/get-device-type';

function mergeCountryCodeAttributes(base) {
  if (base.countryCode && String(base.countryCode).trim()) {
    base.countryCode = String(base.countryCode).trim().toUpperCase();
  }
}

function mergeUtmFromUrl(base) {
  const urlParams = new URLSearchParams(window.location.search);

  UTM_ATTRIBUTES_MAP.forEach(([queryKey, attributeKey]) => {
    const fromUrl = urlParams.get(queryKey);
    if (fromUrl) {
      base[attributeKey] = fromUrl;
    }
  });
}

function mergeSetappUidFromCookie(base) {
  const fromCookie = Cookies.get(COOKIE_CUSTOMER_ID_NAME);
  if (fromCookie && String(fromCookie).trim()) {
    base.setapp_uid = String(fromCookie).trim();
  }
}

function mergeAttributes(cfg) {
  const base = { ...(cfg.attributesBase || {}) };
  mergeUtmFromUrl(base);

  const svn = Cookies.get(SVN_COOKIE_NAME);
  if (svn) {
    base.id = svn;
  }

  mergeCountryCodeAttributes(base);

  base.browser = typeof window === 'undefined' ? '' : getBrowser();
  base.deviceType = typeof window === 'undefined' ? '' : getDeviceType();

  if (!base.setapp_uid) {
    mergeSetappUidFromCookie(base);
  }

  return base;
}

(async function initGrowthBook() {
  const cfg = window.__SETAPP_GROWTHBOOK__;

  if (!(cfg?.clientKey && cfg?.apiHost)) {
    console.warn('[GrowthBook] Skipping init: missing clientKey or apiHost.');

    return;
  }

  const attributes = mergeAttributes(cfg);

  const stickyBucketService = new BrowserCookieStickyBucketService({ jsCookie: Cookies });

  const growthbook = new GrowthBook({
    apiHost: cfg.apiHost,
    clientKey: cfg.clientKey,
    enableDevMode: cfg.enableDevMode,
    stickyBucketService,
    trackingCallback: (_experiment, result) => {
      if ('event' in result.value && result.value.event) {
        window.dataLayer?.push(result.value);
      }
    },
  });

  await growthbook.setAttributes({ ...growthbook.getAttributes(), ...attributes }).catch(() => {});
  await growthbook.init({ timeout: INIT_TIMEOUT_MS }).catch(() => {});
}());
